import apiClient from '../components/apiClient';
import Except from '../models/Except';
import SetupOption from '../models/SetupOpt';
import Style from '../models/Style';

export class ExceptService {
    static addExcept(except: Except): Promise<Except> {
        return apiClient.post<Except>(`/Except/AddExcept`, except).then(res => res.data);
    }

    static getExceptsByStyle(styleCd: string): Promise<Except[]> {
        return apiClient.get<Except[]>(`/Except/GetExceptsByStyle/${styleCd}`)
            .then(res => res.data);
    }

    static getLetteringStyles(query: string): Promise<Style[]> {
        return apiClient.get<Style[]>(`/Except/GetLetteringStyles/${query}`).then(res => res.data);
    }

    static getSetupOptByStyleCd(styleCd: string): Promise<SetupOption[]> {
        return apiClient.get<SetupOption[]>(`/Except/GetSetupOptByStyleCd/${styleCd}`).then(res => res.data);
    }

    static getSetupOptSizeByStyleCd(styleCd: string): Promise<SetupOption[]> {
        return apiClient.get<SetupOption[]>(`/Except/GetSetupOptSizeByStyleCd/${styleCd}`).then(res => res.data);
    }

    static getSetupOptByStyleCdAndDesc(styleCd: string, setupDesc: string): Promise<SetupOption[]> {
        return apiClient.get<SetupOption[]>(`/Except/GetSetupOptByStyleCdAndDesc/${styleCd}/${setupDesc}`).then(res => res.data);
    }

    static updateExcept(except: Except): Promise<boolean> {
        return apiClient.put<boolean>(`/Except/UpdateExcept`, except).then(res => res.data);
    }

    static deleteExcept(exceptId: number): Promise<boolean> {
        return apiClient.delete<boolean>(`/Except/DeleteExcept/${exceptId}`).then(res => res.data);
    }
}
